/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SportInputs */

const en_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const es_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deporte`)
};

const fr_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const de_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const ja_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポーツコーチング`)
};

const zh_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动指导`)
};

const ar_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رياضة`)
};

const id_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olahraga`)
};

const it_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

const ru_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спорт`)
};

const pt_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporte`)
};

const ko_val_sport = /** @type {(inputs: Val_SportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스포츠`)
};

/**
* | output |
* | --- |
* | "Sport" |
*
* @param {Val_SportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sport = /** @type {((inputs?: Val_SportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sport(inputs)
	if (locale === "es") return es_val_sport(inputs)
	if (locale === "fr") return fr_val_sport(inputs)
	if (locale === "de") return de_val_sport(inputs)
	if (locale === "ja") return ja_val_sport(inputs)
	if (locale === "zh") return zh_val_sport(inputs)
	if (locale === "ar") return ar_val_sport(inputs)
	if (locale === "id") return id_val_sport(inputs)
	if (locale === "it") return it_val_sport(inputs)
	if (locale === "ru") return ru_val_sport(inputs)
	if (locale === "pt") return pt_val_sport(inputs)
	return ko_val_sport(inputs)
});